import { PageWithLayout } from '@/pages/_app';
import { Helmet } from 'react-helmet-async';
import { FaqsPageContent } from '@starjack/widgets/faqs';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Permission } from '@/models/user';

export const FaqPage: PageWithLayout = () => {
    return (
        <>
            <Helmet>FAQs | Starjack Backoffice</Helmet>
            <FaqsPageContent />
        </>
    );
};

FaqPage.isProtected = true;
FaqPage.permissions = [Permission.ADMIN];
FaqPage.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;

export default FaqPage;
